module.exports = __webpack_public_path__ + "static/media/m_resident.e169e22c.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/m_resident.csv
// module id = 939
// module chunks = 0